import { style } from '@vanilla-extract/css'
import { vars } from '~/styles/theme.css'

export const placeholderDropdown = style({
  backgroundColor: vars.color.white,
  borderRadius: vars.buttons.radius,
  color: vars.color.dark,
  boxShadow: vars.shadow,
  position: 'relative',
  maxWidth: '350px',
  padding: '0.5rem'
})

export const placeholderList = style({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.8rem',
  overflow: 'auto',
  maxHeight: '300px',
  scrollbarWidth: 'thin',
  scrollbarColor: `${vars.color.medium} transparent`
})

export const placeholderCategoryTitle = style({
  position: 'sticky',
  top: 0,
  backgroundColor: vars.color.white,
  fontWeight: vars.font.bodyBold.weight,
  fontSize: vars.font.bodyBold.size,
  padding: '0.3rem 0.5rem'
})

export const placeholderButton = style({
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  width: '100%',
  textAlign: 'left',
  padding: '0.3rem 0.5rem',
  transition: 'background-color 0.2s',
  fontWeight: vars.font.body.weight,
  fontSize: vars.font.body.size,
  borderRadius: 4,
  color: vars.color.dark,

  ':hover': {
    backgroundColor: vars.color.mediumLighter
  }
})

export const placeholderButtonSelected = style({
  backgroundColor: vars.color.mediumLighter
})

export const placeholderCategoryItems = style({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.1rem'
})

export const placeholderBadge = style({
  userSelect: 'all',
  whiteSpace: 'nowrap !important',
  backgroundColor: vars.color.primary,
  color: vars.color.white,
  borderRadius: vars.buttons.radius,
  padding: '0.1rem 0.5rem',
  fontSize: '0.9rem'
})
